import customWebApplications from '../img/services/Custom web applications.webp';
import nativeCrossPlatformMobileApps from '../img/services/Native & cross-platform mobile apps.webp';
import backEndServicesAndApis from '../img/services/Back-end services & APIs.webp';
import softwareArchitectureDefinition from '../img/services/Software-architecture definition.webp';
import monolithToMicroserviceAndCloudMigrations from '../img/services/Monolith-to-microservice & cloud migrations.webp';
import performanceAndCostOptimization from '../img/services/Performance & cost optimization.webp';

export const skillsSummary = [
  {
    id: 1,
    image: customWebApplications,
    title: 'Custom web applications',
    paragraph:
      'End-to-end Single-Page Apps (SPA) and Progressive Web Apps (PWA): green-field builds or major refactors focused on performance and scalability.',
  },
  {
    id: 2,
    image: nativeCrossPlatformMobileApps,
    title: 'Native & cross-platform mobile apps',
    paragraph:
      'iOS & Android delivery from one codebase, store publication and lifecycle maintenance.',
  },
  {
    id: 3,
    image: backEndServicesAndApis,
    title: 'Back-end services & APIs',
    paragraph:
      'Design and implementation of REST / GraphQL microservices, third-party integrations and database tuning.',
  },
  {
    id: 4,
    image: softwareArchitectureDefinition,
    title: 'Software-architecture definition',
    paragraph: 'High-level diagrams, pattern selection and coding standards.',
  },
  {
    id: 5,
    image: monolithToMicroserviceAndCloudMigrations,
    title: 'Monolith-to-microservice & cloud migrations',
    paragraph: 'Decomposition, containerization, and AWS/on-prem deployments.',
  },
  {
    id: 6,
    image: performanceAndCostOptimization,
    title: 'Performance & cost optimization',
    paragraph: 'Code, database and cloud audits with an improvement roadmap.',
  },
];
